export const stateKeys = {
  schoolPublicProfileLoading: 'schoolPublicProfileLoading',
  schoolPublicVacanciesLoading: 'schoolPublicVacancyLoading',
  schoolPublicProfile: 'schoolPublicProfile',
  schoolPublicVacancies: 'schoolPublicVacancies',
  schoolLogoUrl: 'schoolLogoUrl',
  schoolCoverPhotoUrl: 'schoolCoverPhotoUrl',
  schoolPublicProfileFailedCode: 'schoolPublicProfileFailedCode',
  schoolPublicVacanciesFailedCode: 'schoolPublicVacanciesFailedCode'
};

export const stateLoadingKeys = {
  [stateKeys.schoolPublicProfileLoading]: stateKeys.schoolPublicProfileLoading,
  [stateKeys.schoolPublicVacanciesLoading]: stateKeys.schoolPublicVacanciesLoading,
  [stateKeys.schoolLogoUrlLoading]: stateKeys.schoolLogoUrlLoading,
  [stateKeys.schoolCoverPhotoUrlLoading]: stateKeys.schoolCoverPhotoUrlLoading
};


// WEBPACK FOOTER //
// ./src/constants/school-public-vacancies.js